import { EventBusEvent } from 'common/enums/EventBus';
import eventBus from 'common/event-bus/EventBus';

export const openPaymentMethodSelectionDrawer = () => {
  eventBus.emit(EventBusEvent.TogglePaymentSelectionDrawer, { open: true });
};
